<div class="prompt-text">
  <div class="prompt-text__input-wrapper" #inputWrapper>
    <div class="form">
      <div class="form__row">
        <div class="form__group">
          <div class="form__label-wrapper">
            <label class="form__label" >Von</label>
            <div class="form__error-wrapper" *ngIf="isShowValidation && !dateFrom.length">
              <div  class="form__error">{{"TEACHER_DASHBOARD.SUBMIT_LESSON_IDEA.REQUIRED" | translate}}</div>
            </div>
          </div>
          <input class="form__input form__input--text"
                 onfocus="this.type='date'; this.showPicker()" onblur="this.type='date'"
                 [(ngModel)]="dateFrom" (ngModelChange)="onOpenDateChanged($event)"
                 required type="date" [placeholder]="'TT.MM.JJJJ'">

          <brt-icon [icon]="'calendar'"></brt-icon>
        </div>

        <div class="form__group">
          <div class="form__label-wrapper">
            <label class="form__label">Bis</label>
            <div class="form__error-wrapper" *ngIf="isShowValidation && !dateTo.length">
              <div  class="form__error">{{"TEACHER_DASHBOARD.SUBMIT_LESSON_IDEA.REQUIRED" | translate}}</div>
            </div>
          </div>
          <input class="form__input form__input--text"
                 [(ngModel)]="dateTo" (ngModelChange)="onCloseDateChanged($event)"
                 onfocus="this.type='date'; this.showPicker()" onblur="this.type='date'"
                 required type="date" [placeholder]="'TT.MM.JJJJ'">
          <brt-icon [icon]="'calendar'"></brt-icon>
        </div>
      </div>
    </div>
  </div>

  <div class="prompt-text__actions">
    <div class="prompt-text__action" (click)="onCancelClicked()">
      <brt-button [title]="'Abbrechen'" color="transparent"></brt-button>
    </div>
    <div class="prompt-text__action" (click)="confirm()">
      <brt-button [title]="'Speichern'" color="river" [disabled]="dateFrom.length === 0 || dateTo.length === 0"></brt-button>
    </div>
  </div>
</div>
